import React from 'react';
import styled from '@emotion/styled';
import ThumbnailWrapper from './ThumbnailWrapper';
const Container = styled('div') `
  background-size: 400% 400%;
  background: linear-gradient(-90deg, #eee, #ccc);
  box-sizing: border-box;
  height: 100%;
  width: 100%;
`;
const Placeholder = ({ isLarge, mode }) => {
    return (<ThumbnailWrapper isLarge={isLarge} mode={mode}>
      <Container />
    </ThumbnailWrapper>);
};
export default Placeholder;
